import moment from 'moment'
import i18n from '../i18n';

export default {
  currentFilterPeriod(fiscalYearDate,lastFiscalYearDate,range,  startDate, endDate, paidAtStartDate, paidAtEndDat){
    let currentFilterPeriodTxt= "";
    if(fiscalYearDate.startDate!=null && fiscalYearDate.endDate!=null ){
      if(range=='FISCAL_YEAR'){
        return `${i18n.t('common.forPeriod')} ${fiscalYearDate.startDate.format('DD MMM YYYY')} ${i18n.t('common.forPeriodAt')} ${fiscalYearDate.endDate.format('DD MMM YYYY')}`;
      }else if(range=='LAST_FISCAL_YEAR'){
          return `${i18n.t('common.forPeriod')} ${lastFiscalYearDate.startDate.format('DD MMM YYYY')} ${i18n.t('common.forPeriodAt')} ${lastFiscalYearDate.endDate.format('DD MMM YYYY')}`;
      }else if(moment(startDate).isValid() && endDate != null){
        return `${i18n.t('common.forPeriod')} ${moment(startDate).format('DD MMM YYYY')} ${i18n.t('common.forPeriodAt')} ${moment(endDate).format('DD MMM YYYY')}`;
      } else if (!moment(startDate).isValid() && moment(endDate).isValid()) {
        return `${i18n.t('common.forPerdioUntil')} ${moment(endDate).format('DD MMM YYYY')}`;
      }
      else if(paidAtStartDate != null && paidAtEndDat != null){
        return `${i18n.t('common.forPaymentDate')} ${moment(paidAtStartDate).format('DD MMM YYYY')} ${i18n.t('common.forPeriodAt')} ${moment(paidAtEndDat).format('DD MMM YYYY')}`;
        // return "Dont la date de paiement est entre "+moment(paidAtStartDate).format('DD MMM YYYY') + " au " + moment(paidAtEndDat).format('DD MMM YYYY');
      }
    }
    return currentFilterPeriodTxt;
  }

}
